import { render, staticRenderFns } from "./LogsView.vue?vue&type=template&id=2fdb51f0&scoped=true&"
import script from "./LogsView.vue?vue&type=script&lang=js&"
export * from "./LogsView.vue?vue&type=script&lang=js&"
import style0 from "./LogsView.vue?vue&type=style&index=0&id=2fdb51f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb51f0",
  null
  
)

export default component.exports